var locale = {
  placeholder: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ'
};
export default locale;
//# sourceMappingURL=kn_IN.js.map
